// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Add, SwapHoriz } from '@/constants/hardfin-standard-icons';
import { useAdjustInventory } from '@/items/hooks/use-adjust-inventory';
import { useTransferInventory } from '@/items/hooks/use-transfer-inventory';
import { SparseItem, SparseLocation } from '@/sparse/api/types';
import { Button, Stack } from '@mui/material';

interface InventoryRowActionsProps {
  location?: SparseLocation;
  item?: SparseItem;
}

/**
 * Renders action buttons for inventory rows.
 */
export function InventoryRowActions(props: InventoryRowActionsProps) {
  const { openDialog: openAdjustDialog } = useAdjustInventory();
  const { openDialog: openTransferDialog } = useTransferInventory();

  const handleAdjust = () => {
    openAdjustDialog({
      location: props.location,
      item: props.item,
    });
  };

  const handleTransfer = () => {
    openTransferDialog({
      location: props.location,
      item: props.item,
    });
  };

  return (
    <Stack
      direction="row"
      justifyContent="flex-end"
      spacing={1}
      sx={{
        '& .MuiSvgIcon-root': {
          fontSize: '0.9rem',
        },
      }}
    >
      <Button
        size="small"
        color={'primary'}
        startIcon={<Add />}
        onClick={handleAdjust}
      >
        Adjust
      </Button>
      <Button
        size="small"
        color={'primary'}
        startIcon={<SwapHoriz />}
        onClick={handleTransfer}
      >
        Transfer
      </Button>
    </Stack>
  );
}
